import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormBacklog(props) {
      // Create ref for first input
      const firstInputRef = useRef(null);

      // Focus on first input when component mounts
      useEffect(() => {
          if (firstInputRef.current) {
              firstInputRef.current.focus();
          }
      }, []); // Empty dependency array means this runs once when component mounts
  
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }

    return (
        <>
        <div className="formRow">
            <div className="formGroup">
                <Tooltip title="Remaining backlog that will burn in the current fiscal year. If it is the end of the fiscal year, the number should be zero." arrow placement="top">
                    <FormControl className="formControl">
                        <InputLabel>Current FY</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogBurn)}
                            onChange={onChange}
                            name='backlogBurn'
                            label="Current FY"
                            inputRef={firstInputRef}
                        />
                    </FormControl>
                </Tooltip>
            </div>

            <div className="formGroup">
                <Tooltip title="Backlog that will burn in future fiscal years." arrow placement="top">
                    <FormControl className="formControl">
                        <InputLabel>Future Years</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogBurnFuture)}
                            onChange={onChange}
                            name='backlogBurnFuture'
                            label="Future Years"
                        />
                    </FormControl>
                </Tooltip>
            </div>
            <div className="formGroup">
                <Tooltip title="Gross margin on backlog that will burn in the current fiscal year.  If it is the end of the fiscal year, the number should be zero." arrow placement="top">
                    <FormControl className="formControl">
                        <InputLabel>GM Current FY</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogBurnMargin)}
                            onChange={onChange}
                            name='backlogBurnMargin'
                            label="GM Current FY"
                        />
                    </FormControl>
                </Tooltip>
            </div>
        </div>
        <div className="formRow">
        <div className="formGroup">
                 <Tooltip title="Gross Margin expected on backlog that will burn in future fiscal years." arrow placement="top">
                     <FormControl className="formControl">
                        <InputLabel>GM Future Years</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogBurnFutureMargin)}
                            onChange={onChange}
                            name='backlogBurnFutureMargin'
                            label="GM Future Years"
                        />
                    </FormControl>
                 </Tooltip>
                </div>
        <div className="formGroup">
                  <Tooltip title="Backlog Sold or awarded but not yet formally under contract." arrow placement="top">
                      <FormControl className="formControl">
                        <InputLabel>Sold Backlog</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogSold)}
                            onChange={onChange}
                            name='backlogSold'
                            label="Sold Backlog"
                        />
                    </FormControl>
                  </Tooltip>
            </div>
        
                
            <div className="formGroup">
                 <Tooltip title="Backlog of projects with a high probability of award." arrow placement="top">
                     <FormControl className="formControl">
                        <InputLabel>High Potential</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            value={formatNumber(props.selectedFinancial.backlogPotential)}
                            onChange={onChange}
                            name='backlogPotential'
                            label="High Potential"
                        />
                    </FormControl>
                 </Tooltip>
            </div>
        </div>
           
          
          
           
          
           
        </>
    );
}